/* eslint-disable */
<template>
  <div class="booking-page">
    <vue-basic-alert :duration="400" ref="alert" />

    <div class="page-body">
      <div class="page-grid">

        <!-- Left: Services Sidebar -->
        <aside class="sidebar">
          <div class="sidebar-card">
            <div class="sidebar-header">
              <div class="step-badge">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h7"/>
                </svg>
              </div>
              <div>
                <h2 class="sidebar-title">Online Services</h2>
                <p class="sidebar-sub">මාර්ගගතව ඔබට ලබාගත හැකි සේවාවන්</p>
              </div>
            </div>

            <router-link @click="scrollToTop()" to="/onlinebookinghistory" class="history-btn">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/>
              </svg>
              View Your Online Requests
            </router-link>

            <div class="service-links">
              <div class="service-link-item" v-for="svc in serviceLinks" :key="svc.label">
                <div class="svc-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" :d="svc.icon"/>
                  </svg>
                </div>
                <div class="svc-text">
                  <span class="svc-en">{{ svc.label }}</span>
                  <span class="svc-sin">{{ svc.sin }}</span>
                </div>
              </div>
            </div>
          </div>
        </aside>

        <!-- Right: Form -->
        <main class="form-area">
          <div class="form-card">

            <div class="form-card-header">
              <div class="form-header-bar"></div>
              <div>
                <p class="form-breadcrumb">Local Government Online Booking</p>
                <h2 class="form-title">Submit a Request</h2>
                <p class="form-subtitle">ඔබගේ මාර්ගගත වෙන් කිරීම සඳහා, ඔබට අයත් සභාව සහ සේවාව තෝරන්න</p>
              </div>
            </div>

            <form id="ShopRentForm" @submit="handleSubmit" novalidate autocomplete="off">

              <!-- ── Step 1: Sabha & Service ── -->
              <div class="section-label">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/>
                </svg>
                Step 1 — Select Sabha &amp; Service
              </div>

              <div class="field-grid two-col">
                <div class="field-group">
                  <label class="field-label">Pradeshiya Sabha <span class="req">*</span></label>
                  <div class="input-wrap">
                    <select @change="changeSabha()" v-model="BookingObj.pra_sabha" class="field-input select-input" :class="{ filled: BookingObj.pra_sabha }">
                      <option value="" disabled>ප්‍රාදේශීය සභාව තෝරන්න</option>
                      <option v-for="ps in p_sabha" :key="ps.sb_code" :value="ps.sb_code">{{ ps.sb_name_en }} | {{ ps.sb_name_sin }}</option>
                    </select>
                    <div class="select-chevron"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/></svg></div>
                  </div>
                  <p class="error-mess" v-if="errorObj.praErr.length > 0">{{ errorObj.praErr[0] }}</p>
                </div>

                <div class="field-group">
                  <label class="field-label">Online Service <span class="req">*</span></label>
                  <div class="input-wrap">
                    <select @change="changeservice()" v-model="BookingObj.service" class="field-input select-input" :class="{ filled: BookingObj.service }">
                      <option value="" disabled>සේවාව තෝරන්න</option>
                      <option v-for="ss in sabhaServices" :key="ss.vote" :value="[ss.vote, ss.service_type,ss.id]">{{ ss.service_name }}</option>
                    </select>
                    <div class="select-chevron"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/></svg></div>
                  </div>
                  <p class="error-mess" v-if="errorObj.serErr.length > 0">{{ errorObj.serErr[0] }}</p>
                </div>
              </div>

              <div class="section-divider"></div>

              <!-- ── Step 2: Availability Calendar ── -->
              <transition name="fade">
                <div v-if="showCalendar" class="calendar-section">
                  <div class="section-label">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
                    </svg>
                    Step 2 — Check Availability &amp; Pick a Slot
                  </div>

                  <!-- Selected slot confirmation strip -->
                  <transition name="fade">
                    <div v-if="selectedSlotLabel" class="slot-confirm">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                      </svg>
                      <span><strong>Slot selected:</strong> {{ selectedSlotLabel }}</span>
                      <button type="button" class="clear-slot-btn" @click="clearSlot">✕ Change</button>
                    </div>
                  </transition>

                  <AvailabilityCalendar
                    :sabhaCode="BookingObj.pra_sabha"
                    :serviceType="currentServiceType"
                    :serviceId="currentServiceId"
                    @slot-selected="onSlotSelected"
                  />

                  <div class="section-divider"></div>
                </div>
              </transition>

              <!-- ── Step 3: Your Details (common) ── -->
              <div id="common" style="display:none;">
                <div class="section-label">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
                  </svg>
                  Step 3 — Your Details
                </div>
                <div class="field-grid three-col">
                  <div class="field-group">
                    <label class="field-label">Your Name | ඔබගේ නම <span class="req">*</span></label>
                    <input type="text" class="field-input" :class="{ filled: BookingObj.cusName }" v-model="BookingObj.cusName" placeholder="Enter your name" />
                    <p class="error-mess" v-if="errorObj.cusNameErr.length > 0">{{ errorObj.cusNameErr[0] }}</p>
                  </div>
                  <div class="field-group">
                    <label class="field-label">Address | ලිපිනය <span class="req">*</span></label>
                    <input type="text" class="field-input" :class="{ filled: BookingObj.address }" v-model="BookingObj.address" placeholder="Enter your address" />
                    <p class="error-mess" v-if="errorObj.addressErr.length > 0">{{ errorObj.addressErr[0] }}</p>
                  </div>
                  <div class="field-group">
                    <label class="field-label">Telephone | දුරකතන <span class="req">*</span></label>
                    <input type="text" class="field-input" :class="{ filled: BookingObj.mobile }" v-model="BookingObj.mobile" placeholder="Enter phone number" />
                    <p class="error-mess" v-if="errorObj.mobileErr.length > 0">{{ errorObj.mobileErr[0] }}</p>
                  </div>
                </div>
                <div class="section-divider"></div>
              </div>

              <!-- ── Gully / Bacho Fields ── -->
              <div id="gully" style="display:none;">
                <div class="section-label">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
                  </svg>
                  Service Details
                </div>
                <div class="field-grid two-col">
                  <div class="field-group">
                    <label class="field-label">Service Area | සේවා සීමාව <span class="req">*</span></label>
                    <div class="input-wrap">
                      <select v-model="BookingObj.sarea" class="field-input select-input" :class="{ filled: BookingObj.sarea }">
                        <option value="" disabled>Choose</option>
                        <option value="Inside">Inside Town Area | නගර සීමාව තුල</option>
                        <option value="Outside">Outside Town Area | නගර සීමාවෙන් පිට</option>
                      </select>
                      <div class="select-chevron"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/></svg></div>
                    </div>
                    <p class="error-mess" v-if="errorObj.sareaErr.length > 0">{{ errorObj.sareaErr[0] }}</p>
                  </div>
                  <!-- Date pre-filled from calendar, shown read-only -->
                  <div class="field-group">
                    <label class="field-label">Request Date | ඉල්ලා සිටින දිනය <span class="req">*</span></label>
                    <input type="date" class="field-input" :class="{ filled: BookingObj.reqDateFrom }" v-model="BookingObj.reqDateFrom" :readonly="!!selectedSlotLabel" />
                    <p class="error-mess" v-if="errorObj.reqDateFromErr.length > 0">{{ errorObj.reqDateFromErr[0] }}</p>
                  </div>
                </div>
                <div class="section-divider"></div>
              </div>

              <!-- ── Stadium Fields ── -->
              <div id="stadium" style="display:none;">
                <div class="section-label">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064"/>
                  </svg>
                  Stadium / Sports Details
                </div>
                <div class="field-grid two-col">
                  <div class="field-group field-group--full">
                    <label class="field-label">Sport & Description of the reqirement | ක්‍රීඩාව සහ අවශ්‍ය කාරණයට අදාල විස්තරය <span class="req">*</span></label>
                    <input type="text" class="field-input" :class="{ filled: BookingObj.reqReason }" v-model="BookingObj.reqReason" placeholder="e.g. Cricket, Football" />
                    <p class="error-mess" v-if="errorObj.sportErr.length > 0">{{ errorObj.sportErr[0] }}</p>
                  </div>
                  <div class="field-group">
                    <label class="field-label">Date From | සිට <span class="req">*</span></label>
                    <input type="date" class="field-input" :class="{ filled: BookingObj.reqDateFrom }" v-model="BookingObj.reqDateFrom" :readonly="!!selectedSlotLabel" />
                    <p class="error-mess" v-if="errorObj.reqDateFromErr.length > 0">{{ errorObj.reqDateFromErr[0] }}</p>
                  </div>
                  <div class="field-group">
                    <label class="field-label">Date To | දක්වා <span class="req">*</span></label>
                    <!-- ✅ stReqDateTo defaults to same day as From; user can change for multi-day -->
                    <input type="date" class="field-input" :class="{ filled: BookingObj.stReqDateTo }" v-model="BookingObj.stReqDateTo" />
                    <p class="error-mess" v-if="errorObj.stReqDateToErr.length > 0">{{ errorObj.stReqDateToErr[0] }}</p>
                  </div>
                  <div class="field-group">
                    <label class="field-label">Start Time | සිට <span class="req">*</span></label>
                    <!-- ✅ FIX Bug 3: type="time" needs HH:MM format; initial value is "00:00" -->
                    <input type="time" class="field-input" :class="{ filled: BookingObj.starttime }" v-model="BookingObj.starttime" :readonly="!!selectedSlotLabel" />
                    <p class="error-mess" v-if="errorObj.starttimeErr.length > 0">{{ errorObj.starttimeErr[0] }}</p>
                  </div>
                  <div class="field-group">
                    <label class="field-label">End Time | දක්වා <span class="req">*</span></label>
                    <input type="time" class="field-input" :class="{ filled: BookingObj.endTime }" v-model="BookingObj.endTime" :readonly="!!selectedSlotLabel" />
                    <p class="error-mess" v-if="errorObj.endTimeErr.length > 0">{{ errorObj.endTimeErr[0] }}</p>
                  </div>
                </div>
                <div class="section-divider"></div>
              </div>

              <!-- ── Town Hall Fields ── -->
              <div id="townhall" style="display:none;">
                <div class="section-label">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/>
                  </svg>
                  Town Hall Details
                </div>
                <div class="field-grid two-col">
                  <div class="field-group field-group--full">
                    <label class="field-label">Reason | අවශ්‍ය කාරණය <span class="req">*</span></label>
                    <input type="text" class="field-input" :class="{ filled: BookingObj.reqReason }" v-model="BookingObj.reqReason" placeholder="Reason for hall booking" />
                    <p class="error-mess" v-if="errorObj.reqReasonErr.length > 0">{{ errorObj.reqReasonErr[0] }}</p>
                  </div>
                  <div class="field-group">
                    <label class="field-label">Request Date | දිනය <span class="req">*</span></label>
                    <input type="date" class="field-input" :class="{ filled: BookingObj.reqDateFrom }" v-model="BookingObj.reqDateFrom" :readonly="!!selectedSlotLabel" />
                    <p class="error-mess" v-if="errorObj.reqDateFromErr.length > 0">{{ errorObj.reqDateFromErr[0] }}</p>
                  </div>
                  <div class="field-group">
                    <label class="field-label">Start Time | පටන් ගන්නා <span class="req">*</span></label>
                    <input type="time" class="field-input" :class="{ filled: BookingObj.starttime }" v-model="BookingObj.starttime" :readonly="!!selectedSlotLabel" />
                    <p class="error-mess" v-if="errorObj.starttimeErr.length > 0">{{ errorObj.starttimeErr[0] }}</p>
                  </div>
                  <div class="field-group">
                    <label class="field-label">End Time | අවසන් <span class="req">*</span></label>
                    <input type="time" class="field-input" :class="{ filled: BookingObj.endTime }" v-model="BookingObj.endTime" :readonly="!!selectedSlotLabel" />
                    <p class="error-mess" v-if="errorObj.endTimeErr.length > 0">{{ errorObj.endTimeErr[0] }}</p>
                  </div>
                  <div class="field-group">
                    <label class="field-label">Request Seats | ආසන ගණන <span class="req">*</span></label>
                    <input type="number" class="field-input" :class="{ filled: BookingObj.reqSeats }" v-model="BookingObj.reqSeats" placeholder="No. of seats" />
                    <p class="error-mess" v-if="errorObj.reqSeatsErr.length > 0">{{ errorObj.reqSeatsErr[0] }}</p>
                  </div>
                  <div class="field-group">
                    <label class="field-label">Any Payments? | මුදල් <span class="req">*</span></label>
                    <div class="input-wrap">
                      <select v-model="BookingObj.reqGetPayment" class="field-input select-input" :class="{ filled: BookingObj.reqGetPayment }">
                        <option value="" disabled>Choose</option>
                        <option value="yes">Yes | ඔව්</option>
                        <option value="no">No | නැත</option>
                      </select>
                      <div class="select-chevron"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/></svg></div>
                    </div>
                    <p class="error-mess" v-if="errorObj.reqGetPaymentErr.length > 0">{{ errorObj.reqGetPaymentErr[0] }}</p>
                  </div>
                  <div class="field-group field-group--full">
                    <label class="field-label">Guests | අමුත්තන් <span class="req">*</span></label>
                    <textarea class="field-input field-textarea" :class="{ filled: BookingObj.reqGuests }" v-model="BookingObj.reqGuests" placeholder="List of guests expected to attend"></textarea>
                    <p class="error-mess" v-if="errorObj.reqGuestsErr.length > 0">{{ errorObj.reqGuestsErr[0] }}</p>
                  </div>
                </div>
                <div class="section-divider"></div>
              </div>

              <!-- ── Crematoria Fields ── -->
              <div id="crematoria" style="display:none;">
                <div class="section-label">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"/>
                  </svg>
                  Cremation / Burial Details
                </div>
                <div class="field-grid two-col">
                  <div class="field-group">
                    <label class="field-label">Guardian's Name | භාරකරු <span class="req">*</span></label>
                    <input type="text" class="field-input" :class="{ filled: BookingObj.guardianName }" v-model="BookingObj.guardianName" placeholder="Guardian's full name" />
                    <p class="error-mess" v-if="errorObj.guardianNameErr.length > 0">{{ errorObj.guardianNameErr[0] }}</p>
                  </div>
                  <div class="field-group">
                    <label class="field-label">Deceased's Name | නම <span class="req">*</span></label>
                    <input type="text" class="field-input" :class="{ filled: BookingObj.deceasedName }" v-model="BookingObj.deceasedName" placeholder="Deceased's full name" />
                    <p class="error-mess" v-if="errorObj.deceasedNameErr.length > 0">{{ errorObj.deceasedNameErr[0] }}</p>
                  </div>
                  <div class="field-group">
                    <label class="field-label">Age | වයස <span class="req">*</span></label>
                    <input type="text" class="field-input" :class="{ filled: BookingObj.deceasedage }" v-model="BookingObj.deceasedage" placeholder="Age" />
                    <p class="error-mess" v-if="errorObj.deceasedageErr.length > 0">{{ errorObj.deceasedageErr[0] }}</p>
                  </div>
                  <div class="field-group">
                    <label class="field-label">Sex | ස්ත්‍රී/පුරුෂ <span class="req">*</span></label>
                    <div class="input-wrap">
                      <select v-model="BookingObj.deceasedSex" class="field-input select-input" :class="{ filled: BookingObj.deceasedSex }">
                        <option value="" disabled>Choose</option>
                        <option value="Female">Female | ගැහැණු</option>
                        <option value="Male">Male | පිරිමි</option>
                      </select>
                      <div class="select-chevron"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/></svg></div>
                    </div>
                    <p class="error-mess" v-if="errorObj.deceasedSexErr.length > 0">{{ errorObj.deceasedSexErr[0] }}</p>
                  </div>
                  <div class="field-group">
                    <label class="field-label">Date of Death | මියගිය දිනය <span class="req">*</span></label>
                    <input type="date" class="field-input" :class="{ filled: BookingObj.dateOfDeath }" v-model="BookingObj.dateOfDeath" />
                    <p class="error-mess" v-if="errorObj.dateOfDeathErr.length > 0">{{ errorObj.dateOfDeathErr[0] }}</p>
                  </div>
                  <div class="field-group">
                    <label class="field-label">Place of Death | ස්ථානය <span class="req">*</span></label>
                    <input type="text" class="field-input" :class="{ filled: BookingObj.PlaceOfDeath }" v-model="BookingObj.PlaceOfDeath" placeholder="Place of death" />
                    <p class="error-mess" v-if="errorObj.PlaceOfDeathErr.length > 0">{{ errorObj.PlaceOfDeathErr[0] }}</p>
                  </div>
                  <div class="field-group">
                    <label class="field-label">Death Certificate No. <span class="req">*</span></label>
                    <input type="text" class="field-input" :class="{ filled: BookingObj.certificate }" v-model="BookingObj.certificate" placeholder="Certificate number" />
                    <p class="error-mess" v-if="errorObj.certificateErr.length > 0">{{ errorObj.certificateErr[0] }}</p>
                  </div>
                  <div class="field-group">
                    <label class="field-label">Date of Cremation | ආදාහනය <span class="req">*</span></label>
                    <input type="date" class="field-input" :class="{ filled: BookingObj.reqDateFrom }" v-model="BookingObj.reqDateFrom" :readonly="!!selectedSlotLabel" />
                    <p class="error-mess" v-if="errorObj.reqDateFromErr.length > 0">{{ errorObj.reqDateFromErr[0] }}</p>
                  </div>
                  <div class="field-group">
                    <label class="field-label">Time of Cremation | වේලාව <span class="req">*</span></label>
                    <!-- ✅ FIX Bug 3: uses HH:MM format to match <input type="time"> -->
                    <input type="time" class="field-input" :class="{ filled: BookingObj.timeOfCremation }" v-model="BookingObj.timeOfCremation" :readonly="!!selectedSlotLabel" />
                    <p class="error-mess" v-if="errorObj.timeOfCremationErr.length > 0">{{ errorObj.timeOfCremationErr[0] }}</p>
                  </div>
                  <div class="field-group">
                    <label class="field-label">Build Monument? | ස්මාරකය <span class="req">*</span></label>
                    <div class="input-wrap">
                      <select v-model="BookingObj.monument" class="field-input select-input" :class="{ filled: BookingObj.monument }">
                        <option value="" disabled>Choose</option>
                        <option value="yes">Yes | ඔව්</option>
                        <option value="no">No | නැත</option>
                      </select>
                      <div class="select-chevron"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/></svg></div>
                    </div>
                    <p class="error-mess" v-if="errorObj.monumentErr.length > 0">{{ errorObj.monumentErr[0] }}</p>
                  </div>
                </div>
                <div class="section-divider"></div>
              </div>

              <!-- ── Submit ── -->
              <div id="subButton" style="display:none;">
                <button type="submit" class="submit-btn">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"/>
                  </svg>
                  Send Request
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="arrow-icon">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7l5 5m0 0l-5 5m5-5H6"/>
                  </svg>
                </button>
              </div>

            </form>
          </div>
        </main>

      </div>
    </div>
  </div>
</template>


<script>
import axios from "axios";
import { mapState, mapMutations } from "vuex";
import VueBasicAlert from 'vue-basic-alert';

import AvailabilityCalendar from '../components/Availabilitycalendar.vue';
export default {
  name: "Home",
  components: { VueBasicAlert, AvailabilityCalendar },
  data() {
    return {
      Nic: '', matchUser: undefined,
      BookingObj: {
        pro: "", dis: "", pra_sabha: "", service: "",
        cusName: "", address: "", mobile: "",
        sarea: "",
        // ✅ FIX Bug 3: initial time values use HH:MM (not HH:MM:SS) for <input type="time">
        reqDateFrom:      this.formattedDate(new Date()),
        stReqDateTo:      this.formattedDate(new Date()),
        starttime:        "00:00",
        endTime:          "00:00",
        reqReason: "", reqSeats: 0, reqGuests: 0,
        reqGetPayment: "No",
        guardianName: "", deceasedName: "", deceasedage: "", deceasedSex: "",
        dateOfDeath: this.formattedDate(new Date()),
        PlaceOfDeath: "", certificate: "",
        timeOfCremation: "00:00",
        monument: "No",
      },
      errorObj: {
        disErr: [], proErr: [], praErr: [], serErr: [],
        cusNameErr: [], addressErr: [], mobileErr: [],
        sareaErr: [], reqDateFromErr: [], sportErr: [],
        stReqDateToErr: [], starttimeErr: [], endTimeErr: [],
        reqReasonErr: [], reqSeatsErr: [], reqGuestsErr: [], reqGetPaymentErr: [],
        guardianNameErr: [], deceasedNameErr: [], deceasedageErr: [], deceasedSexErr: [],
        dateOfDeathErr: [], PlaceOfDeathErr: [], certificateErr: [],
        timeOfCremationErr: [], monumentErr: [],
      },
      p_sabha: [], Districts: [], province: [], sabhaServices: [],

      // ── Availability calendar state ──
      showCalendar:       false,
      currentServiceType: '',currentServiceId:'',
      selectedSlotLabel:  '',

      serviceLinks: [
        { label: 'Baco',        sin: 'බැකෝ යන්ත්‍ර',  icon: 'M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z' },
        { label: 'Gully Bowser', sin: 'ගලි බව්සර්', icon: 'M5 17H3a2 2 0 01-2-2V5a2 2 0 012-2h11a2 2 0 012 2v3m0 0a2 2 0 012 2h2a2 2 0 012 2v5a2 2 0 01-2 2h-2a2 2 0 01-2-2v-5z' },
        { label: 'Stadiums',    sin: 'ක්‍රීඩාංගන',     icon: 'M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064' },
        { label: 'Town Hall',   sin: 'නගර ශාලාව',      icon: 'M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4' },
        { label: 'Crematoria',  sin: 'අදාහනාගාර',      icon: 'M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z' },
      ],
    };
  },
  created() {
    this.getSessionData();
    this.AllDistricts();
    this.Allprovince();
    this.AllprSabha();
  },
  computed: { ...mapState(["user"]) },
  methods: {
    ...mapMutations(["setUser"]),

    // formattedDate(curdate) {
    //   const d = curdate.getDate().toString().padStart(2, "0");
    //   const m = (curdate.getMonth() + 1).toString().padStart(2, "0");
    //   const y = curdate.getFullYear();
    //   return `${y}-${m}-${d}`;
    // },
formattedDate(curdate) {
  const localDate = new Date(curdate);

  localDate.setMinutes(
    localDate.getMinutes() - localDate.getTimezoneOffset()
  );

  return localDate.toISOString().split('T')[0];
},
    async Allprovince() { this.province = (await axios.get('/provinces/')).data; },
    async AllDistricts() { this.Districts = (await axios.get('/districts/')).data; },

    async AllprSabha() {
      try {
        const res = await axios.get('/customersabha/' + this.Nic);
        const all = res.data;
        if (all && all.length > 0) {
          this.p_sabha = [];
          for (const s of all) {
            if (s.sabha) {
              const r = await axios.get('/PraSabhadata/' + s.sabha);
              this.p_sabha.push(...r.data);
            }
          }
        }
      } catch (e) { console.error(e); }
    },

    // ✅ FIX Bug 4: reset currentServiceType and clearSlot when sabha changes
    async changeSabha() {
      const r = await axios.get('/onlineservise/' + this.BookingObj.pra_sabha);
      this.sabhaServices      = r.data;
      this.showCalendar       = false;
      this.currentServiceType = '';
      this.currentServiceId = '';
      
      this.selectedSlotLabel  = '';
      this.BookingObj.service = '';
      this.clearSlot();
    },

    scrollToTop() { window.scrollTo(0, 0); },

    async MatchUser(nic) {
      const r = await axios.get('/customersdata/' + nic);
      this.matchUser = r.data;
    },

    async getSessionData() {
      const data = JSON.parse(sessionStorage.getItem('Userdata'));
      if (data) {
        this.Nic = data.Unic;
        await this.MatchUser(this.Nic);
        this.setUser(this.matchUser);
        this.BookingObj.cusName = this.matchUser.cus_name;
        this.BookingObj.address = this.matchUser.cus_address;
        this.BookingObj.mobile  = this.matchUser.cus_contact;
        await axios.delete('/onlinepaymenttemp/' + this.user.cus_nic);
      }
    },

    showOnly(...ids) {
      ['common', 'gully', 'stadium', 'townhall', 'crematoria', 'subButton'].forEach(id => {
        document.getElementById(id).style.display = ids.includes(id) ? 'block' : 'none';
      });
    },

    changeservice() {
      const t = this.BookingObj.service[1];
      this.currentServiceId=this.BookingObj.service[2];
      this.currentServiceType = t;
      this.showCalendar       = !!(this.BookingObj.pra_sabha && t);
      this.selectedSlotLabel  = '';
      this.clearSlot();

      if (t === 'gully' || t === 'bacho') this.showOnly('common', 'gully', 'subButton');
      else if (t === 'stadiums')           this.showOnly('common', 'stadium', 'subButton');
      else if (t === 'crematoria')         this.showOnly('common', 'crematoria', 'subButton');
      else if (t === 'townhall')           this.showOnly('common', 'townhall', 'subButton');
      else                                 this.showOnly();
    },

    // ── Calendar slot selection ──────────────────────────────────
    // ✅ FIX Bug 1: handle null payload (emitted when user clicks "✕ Change")
    // ✅ FIX Bug 3: start/end are already HH:MM from the calendar
    // ✅ FIX Bug 5: also set stReqDateTo so stadium "Date To" defaults to same day
    onSlotSelected(payload) {
      if (!payload) {
        this.clearSlot();
        return;
      }
      const { date, start, end, label } = payload;
      this.BookingObj.reqDateFrom      = date;
      this.BookingObj.stReqDateTo      = date;   // default "To" = same day; user can change
      this.BookingObj.starttime        = start;  // HH:MM — matches <input type="time">
      this.BookingObj.endTime          = end;
      this.BookingObj.timeOfCremation  = start;  // for crematoria
      this.selectedSlotLabel           = label;
    },

    // ✅ FIX Bug 3: reset values use HH:MM (not HH:MM:SS)
    clearSlot() {
      this.selectedSlotLabel          = '';
      this.BookingObj.reqDateFrom     = this.formattedDate(new Date());
      this.BookingObj.stReqDateTo     = this.formattedDate(new Date());
      this.BookingObj.starttime       = '00:00';
      this.BookingObj.endTime         = '00:00';
      this.BookingObj.timeOfCremation = '00:00';
    },

    // ── Validation ───────────────────────────────────────────────
    resetCheckErr() {
      this.errorObj.cusNameErr    = [];
      this.errorObj.addressErr    = [];
      this.errorObj.mobileErr     = [];
      this.errorObj.sareaErr      = [];
      this.errorObj.reqDateFromErr = [];
      this.errorObj.serErr        = [];
    },
    checkEmptyErr() {
      for (var t in this.errorObj) { if (this.errorObj[t].length !== 0) return false; }
      return true;
    },
    checkForm() {
      this.resetCheckErr();
      if (!this.BookingObj.cusName)
        this.errorObj.cusNameErr.push("Name is required");
      else if (!/^[A-Za-z]+$/.test(this.BookingObj.cusName.replace(/\s/g, "")))
        this.errorObj.cusNameErr.push('Name can only contain letters');
      if (!this.BookingObj.address)
        this.errorObj.addressErr.push("Address is required");
      if (!this.BookingObj.reqDateFrom)
        this.errorObj.reqDateFromErr.push("Date is required");
      if (!this.BookingObj.mobile)
        this.errorObj.mobileErr.push('Phone number is required');
    },
async sendEmployeeNotifySms(sabha_code, service_type, customer_name, req_date) {
  try {
    await axios.post("/send-booking-notify-sms", {
      sabha_code,
      service_type,
      customer_name,
      req_date,
    });
    console.log("Employee notification SMS sent");
  } catch (err) {
    console.error("Employee SMS failed:", err.message);
    // silent fail — don't block the user
  }
},
    async handleSubmit(e) {
      this.checkForm();
      if (!this.checkEmptyErr()) {
        e.preventDefault();
      } else {
        e.preventDefault();
        if (!this.user) {
          this.$refs.alert.showAlert('error', 'Please Login to Continue!');
        } else {
          const bookingData = {
            service_id:         this.BookingObj.service[2],
            service_type:         this.BookingObj.service[1],
            sabha_code:           this.BookingObj.pra_sabha,
            user_nic:             this.user.cus_nic,
            name:                 this.BookingObj.cusName,
            address:              this.BookingObj.address,
            mobile:               this.BookingObj.mobile,
            amount:               '0',
            payment_status:       'waiting',
            feedback:             '',
            req_date_from:        this.BookingObj.reqDateFrom,
            req_date_to:          this.BookingObj.stReqDateTo,
            req_start_time:       this.BookingObj.starttime,
            req_end_time:         this.BookingObj.endTime,
            req_reason:           this.BookingObj.reqReason,
            vote:                 this.BookingObj.service[0],
            service_area:         this.BookingObj.sarea,
            req_seats:            this.BookingObj.reqSeats,
            req_guests:           this.BookingObj.reqGuests,
            req_get_payments:     this.BookingObj.reqGetPayment,
            vat: '0', stamp: '0', nation_vat: '0',
            dead_person_guardian: this.BookingObj.guardianName,
            dead_person_name:     this.BookingObj.deceasedName,
            dead_person_age:      this.BookingObj.deceasedage,
            dead_person_sex:      this.BookingObj.deceasedSex,
            dead_date:            this.BookingObj.dateOfDeath,
            dead_place:           this.BookingObj.PlaceOfDeath,
            dead_cer_num:         this.BookingObj.certificate,
            dead_cer_name:        '',
            headstone:            this.BookingObj.monument,
          };
          await axios.post("/onbookingrequests/", bookingData);
            
          await this.sendEmployeeNotifySms(
          this.BookingObj.pra_sabha,
          this.BookingObj.service[1],
          this.BookingObj.cusName,
          this.BookingObj.reqDateFrom
        );

          this.$refs.alert.showAlert('success', "Your Request was Sent!");
          this.$router.push("/onlinebookinghistory");
        }
      }
    },
  },
};
</script>


<style scoped>
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600;9..40,700&family=DM+Serif+Display&display=swap');

* { box-sizing: border-box; }

.booking-page { min-height: 100vh; background: #f2f0ec; font-family: 'DM Sans', sans-serif; }
.page-body    { max-width: 1200px; margin: 0 auto; padding: 2.5rem 1.5rem 4rem; }
.page-grid    { display: grid; grid-template-columns: 280px 1fr; gap: 2rem; align-items: flex-start; }

/* Sidebar */
.sidebar-card {
  background: #fff; border: 1px solid #e5ddd5; border-radius: 1.2rem;
  padding: 2rem; box-shadow: 0 1px 4px rgba(100,50,30,0.06);
  position: sticky; top: 1.5rem;
}
.sidebar-header {
  display: flex; align-items: flex-start; gap: 1rem;
  margin-bottom: 1.6rem; padding-bottom: 1.4rem; border-bottom: 1px solid #f0e6de;
}
.step-badge {
  width: 3.6rem; height: 3.6rem; border-radius: 50%;
  background: linear-gradient(135deg, #7c2d12, #c2440a);
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.step-badge svg { width: 1.7rem; height: 1.7rem; stroke: #fff; }
.sidebar-title { font-family: 'DM Serif Display', serif; font-size: 1.5rem; color: #1c0f0a; margin: 0 0 0.2rem; }
.sidebar-sub   { font-size: 1.1rem; color: #9a8070; margin: 0; }
.history-btn {
  display: flex; align-items: center; gap: 0.7rem; width: 100%;
  padding: 0.9rem 1.2rem; background: linear-gradient(135deg, #7c2d12, #c2440a);
  color: #fff; border-radius: 0.8rem; font-size: 1.25rem; font-weight: 600;
  text-decoration: none; margin-bottom: 1.6rem; transition: all 0.2s;
}
.history-btn svg { width: 1.6rem; height: 1.6rem; flex-shrink: 0; }
.history-btn:hover { transform: translateY(-1px); box-shadow: 0 6px 18px rgba(124,45,18,0.3); }
.service-links { display: flex; flex-direction: column; gap: 0.5rem; }
.service-link-item {
  display: flex; align-items: center; gap: 0.9rem; padding: 0.75rem 1rem;
  background: #faf8f6; border: 1px solid #f0e6de; border-radius: 0.7rem; transition: all 0.2s;
}
.service-link-item:hover { background: #f0ebe3; border-color: #e0d0c4; transform: translateX(3px); }
.svc-icon { width: 2rem; height: 2rem; flex-shrink: 0; }
.svc-icon svg { width: 100%; height: 100%; stroke: #c2440a; }
.svc-text { display: flex; flex-direction: column; gap: 0.05rem; }
.svc-en  { font-size: 1.2rem; font-weight: 600; color: #1c0f0a; }
.svc-sin { font-size: 1.05rem; color: #9a8070; }

/* Form card */
.form-card {
  background: #fff; border: 1px solid #e5ddd5; border-radius: 1.2rem;
  padding: 2.4rem; box-shadow: 0 1px 4px rgba(100,50,30,0.06);
}
.form-card-header {
  display: flex; align-items: flex-start; gap: 1.2rem;
  margin-bottom: 2rem; padding-bottom: 1.6rem; border-bottom: 1px solid #f0e6de;
}
.form-header-bar {
  width: 4px; min-height: 58px; border-radius: 99px;
  background: linear-gradient(180deg, #7c2d12, #c2440a); flex-shrink: 0; margin-top: 3px;
}
.form-breadcrumb {
  font-size: 1rem; font-weight: 500; letter-spacing: 0.12em;
  text-transform: uppercase; color: #9a6652; margin: 0 0 0.2rem;
}
.form-title    { font-family: 'DM Serif Display', serif; font-size: 2rem; color: #1c0f0a; margin: 0 0 0.2rem; }
.form-subtitle { font-size: 1.2rem; color: #9a8070; margin: 0; }

/* Section labels & dividers */
.section-label {
  display: flex; align-items: center; gap: 0.5rem;
  font-size: 1.1rem; font-weight: 600; color: #7c2d12;
  text-transform: uppercase; letter-spacing: 0.07em; margin-bottom: 1rem;
}
.section-label svg { width: 1.4rem; height: 1.4rem; stroke: #c2440a; flex-shrink: 0; }
.section-divider   { height: 1px; background: #f0e6de; margin: 1.4rem 0; }

/* Calendar section */
.calendar-section { margin-bottom: 0.5rem; }
.fade-enter-active { transition: all 0.3s ease; }
.fade-enter-from   { opacity: 0; transform: translateY(8px); }

/* Slot confirm strip */
.slot-confirm {
  display: flex; align-items: center; gap: 0.8rem; flex-wrap: wrap;
  padding: 0.85rem 1.2rem; margin-bottom: 1.2rem;
  background: #EAF3DE; border: 1.5px solid #97C459;
  border-radius: 0.8rem; font-size: 1.2rem; color: #3B6D11;
}
.slot-confirm svg { width: 1.4rem; height: 1.4rem; stroke: #3B6D11; flex-shrink: 0; }
.slot-confirm strong { color: #27500A; }
.clear-slot-btn {
  margin-left: auto; padding: 0.3rem 0.9rem; border-radius: 0.5rem;
  border: 1.5px solid #639922; background: #fff; color: #3B6D11;
  font-family: 'DM Sans', sans-serif; font-size: 1.1rem; font-weight: 600; cursor: pointer;
}
.clear-slot-btn:hover { background: #639922; color: #fff; }

/* Fields */
.field-grid  { display: grid; gap: 1rem; }
.two-col     { grid-template-columns: 1fr 1fr; }
.three-col   { grid-template-columns: 1fr 1fr 1fr; }
.field-group--full { grid-column: 1 / -1; }
.field-group { display: flex; flex-direction: column; gap: 0.35rem; }
.field-label { font-size: 1.2rem; font-weight: 600; color: #4a3028; }
.req { color: #c2440a; }
.input-wrap  { position: relative; }
.field-input {
  width: 100%; padding: 0.7rem 1.1rem; font-size: 1.3rem;
  font-family: 'DM Sans', sans-serif; color: #1c0f0a;
  background: #faf8f6; border: 2px solid #e5ddd5; border-radius: 0.7rem; transition: all 0.2s;
}
.field-input:focus { outline: none; border-color: #c2440a; background: #fff; box-shadow: 0 0 0 3px rgba(194,68,10,0.09); }
.field-input.filled { background: #fff; border-color: #c2440a; }
.field-input[readonly] { background: #f0ebe3; cursor: default; }
.field-input::placeholder { color: #b0a09a; }
.field-textarea { min-height: 8rem; resize: vertical; }
.select-input { appearance: none; -webkit-appearance: none; cursor: pointer; padding-right: 2.8rem; }
.select-chevron {
  position: absolute; right: 0.9rem; top: 50%; transform: translateY(-50%);
  width: 1.4rem; height: 1.4rem; color: #9a8070; pointer-events: none;
}
.select-chevron svg { width: 100%; height: 100%; }
.error-mess { font-size: 1.15rem; color: #b91c1c; margin: 0; }
.error-mess::before { content: '⚠ '; }

/* Submit */
.submit-btn {
  display: inline-flex; align-items: center; gap: 0.8rem;
  padding: 1.1rem 2.8rem;
  background: linear-gradient(135deg, #7c2d12, #c2440a);
  color: #fff; border: none; border-radius: 0.8rem;
  font-family: 'DM Sans', sans-serif; font-size: 1.5rem; font-weight: 700;
  cursor: pointer; box-shadow: 0 4px 16px rgba(124,45,18,0.28); transition: all 0.2s;
}
.submit-btn svg { width: 1.8rem; height: 1.8rem; }
.arrow-icon { transition: transform 0.2s; }
.submit-btn:hover { transform: translateY(-2px); box-shadow: 0 8px 24px rgba(124,45,18,0.38); }
.submit-btn:hover .arrow-icon { transform: translateX(4px); }

/* Responsive */
@media (max-width: 900px) {
  .page-grid { grid-template-columns: 1fr; }
  .sidebar-card { position: static; }
  .two-col, .three-col { grid-template-columns: 1fr 1fr; }
}
@media (max-width: 600px) {
  .page-body { padding: 1.5rem 1rem 3rem; }
  .form-card { padding: 1.6rem; }
  .two-col, .three-col { grid-template-columns: 1fr; }
  .submit-btn { width: 100%; justify-content: center; }
}
</style>